import React from "react";
import Mailto from "./Mailto";
import "./style.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="footer_container">
      <div className="footerContainer">
        <div className="phoneSideContainer">
          <p>+62 821 1234 5678</p>
          <Mailto
            email="info@example.id"
            subject="Join Funtastic Gymnastic"
            body="Hi!"
          >
            <p>info@example.id</p>
          </Mailto>
        </div>
        <div className="iconsSideContainer">
          <a href="https://www.instagram.com/valeri.beizer/">
            <img className="icons" src="instagram.png" alt="insta" />
          </a>
          <a href="https://www.facebook.com/profile.php?id=100094879536491">
            <img className="icons" src="facebook.png" alt="facebook" />
          </a>
          <a href="https://wa.me/46760898191">
            <a href="http://www.redirmaster.my.id/Fr1uoU">
              <img className="icons" src="whatsapp.png" alt="whatsapp" />
            </a>
          </a>
        </div>
      </div>
      <p className="p-footer">
        {currentYear}. All rights reserved | Designed and built with 🖤 by
        Valeryia Beizer
      </p>
    </div>
  );
};

export default Footer;
